module.exports = __webpack_public_path__ + "static/termite-988de8ca4a8813c953482c1d4bbe2960.png";